import { render, staticRenderFns } from "./FailureDetails.vue?vue&type=template&id=0861b654&scoped=true&"
import script from "./FailureDetails.vue?vue&type=script&lang=js&"
export * from "./FailureDetails.vue?vue&type=script&lang=js&"
import style0 from "./FailureDetails.vue?vue&type=style&index=0&id=0861b654&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0861b654",
  null
  
)

export default component.exports